import React, { Component } from "react";
// import Signup from './Signup';
import Forgetpass from "./forgetpass";
import { withRouter } from "react-router-dom";
// import Fileupload from './fileupload/fileupload';
// import {Redirect } from "react-router-dom";
// import Home from './home';
import { auth } from "./firebase/firebaseconfig";

import {
  SessionContext,
  getSessionCookie,
  setSessionCookie,
} from "./session.ts";

import MicrosoftLoginButton from "./components/firebase/MicrosoftLoginButton";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      email: "",
      pwd: "",
      loginSuccess: this.props.loginSuccess,
      ErrorMessage: null,
    };
  }

  componentDidMount() {
    var page = this;

    page.setState({ session: getSessionCookie() }, () => {
      if (page.state.session != null) {
        page.props.history.push("/home");
      }
    });
  }

  handleSubmit = async (event) => {
    const page = this;
    event.preventDefault();
    page.setState({ isLoading: true });
    if (page.state.email != "" && this.state.pwd != "") {
      try {
        auth
          .signInWithEmailAndPassword(page.state.email, page.state.pwd)
          .then(() => {
            // this.setState({loginSuccess:true})

            this.setState({ ErrorMessage: "Success!!!" });
            var emailAddr = page.state.email;
            setSessionCookie({ emailAddr });
            window.location.href = "/home";
            this.props.LoginInValue(true);
            // this.props.LoginInValue(true)
            // this.props.history.push('/analysis')
            // return <Fileupload loginSuccess={this.state.loginSuccess} />
            //    return <Redirect to='/analysis' />
          })
          .catch((error) => {
            // alert("Incorrect credentials!!!!!!!!")
            setTimeout(() => {
              this.setState({
                ErrorMessage: "Incorrect username or password.",
              });
            }, 1000);

            page.setState({ isLoading: false });
            // ReactDOM.render(<ErrorMessage {...this.props} ErrorMessage={this.state.ErrorMessage} />,
            //     document.getElementById('MyErr1'))
          });
      } catch (e) {
        console.log(e);

        this.setState({
          ErrorMessage: "Incorrect username or password.",
        });
        page.setState({ isLoading: false });
        // ReactDOM.render(<ErrorMessage {...this.props} ErrorMessage={this.state.ErrorMessage} />,
        //     document.getElementById('MyErr1'))
        // page.setState({ isLoading: false })
      }
    } else {
      this.setState({ ErrorMessage: "Please enter the username & password" });
    }
  };

  handleChange = (event) => {
    const page = this;

    page.setState({
      [event.target.id]: event.target.value,
    });
  };

  setErrorMessage(message) {
    this.setState({ ErrorMessage: message });
  }

  render() {
    return (
      <div
        className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-column-fluid bg-white"
        id="kt_login"
      >
        <div className="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-10">
          <div className="d-flex flex-row-fluid flex-column justify-content-between">
            <a href="#" className="flex-column-auto mt-5 pb-lg-0 pb-10">
              {/* <img src="assets/media/logos/Powerweave_B.svg" className="max-h-70px" alt="" /> */}
              <img
                src="assets/media/layout/PCNA_Logo_RGB_FINAL_TM_LIGHT.png"
                height="70px"
                alt=""
              />
            </a>

            <div className="flex-column-fluid d-flex flex-column justify-content-center">
              <h3 className="font-size-h1 mb-5 text-white">
                PCNA Large Order Desk System
              </h3>
            </div>

            <div className="d-none flex-column-auto d-lg-flex justify-content-between mt-10">
              <div className="opacity-70 font-weight-bold text-white">
                © 2020 ArtworkServicesUSA / Powerweave Software Services Pvt
                Ltd.
              </div>
              {/* <div className="d-flex">
                            <a href="#" className="text-white">Privacy</a>
                            <a href="#" className="text-white ml-10">Legal</a>
                            <a href="#" className="text-white ml-10">Contact</a>
                        </div> */}
            </div>
          </div>
        </div>

        <div className="d-flex flex-column flex-row-fluid position-relative p-7 overflow-hidden">
          <div className="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10">
            {/* <span className="font-weight-bold text-dark-50">Dont have an account yet?</span>
                    <a href="javascript:;" className="font-weight-bold ml-2" id="kt_login_signup">Sign Up!</a> */}
          </div>

          <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
            <div className="login-form login-signin">
              <div className="text-center my-8">
                <img
                  src="assets/media/layout/PCNA_Logo_RGB_FINAL_TM.png"
                  height="30px"
                  alt=""
                />
              </div>
              <div className="text-center mb-10">
                <h3 className="h6 text-muted">Sign In into PCNA-LODS</h3>
              </div>
              {this.state.ErrorMessage &&
                this.state.ErrorMessage.length > 0 && (
                  <div className="mb-5">{this.state.ErrorMessage}</div>
                )}
              <form
                className="form"
                novalidate="novalidate"
                id="kt_login_signin_form"
                onSubmit={(e) => e.preventDefault()}
              >
                <div className="form-group">
                  <input
                    className="form-control form-control-solid h-auto py-5 px-6"
                    type="email"
                    value={this.state.email}
                    onChange={this.handleChange.bind(this)}
                    id="email"
                    placeholder="Username"
                    name="username"
                    autocomplete="off"
                  />
                </div>
                <div className="form-group">
                  <input
                    className="form-control form-control-solid h-auto py-5 px-6"
                    type="password"
                    value={this.state.pwd}
                    onChange={this.handleChange.bind(this)}
                    id="pwd"
                    placeholder="Password"
                    name="password"
                    autocomplete="off"
                  />
                </div>
                <div className="d-flex flex-wrap justify-content-between align-items-center">
                  <button
                    type="button"
                    className="btn btn-primary font-weight-bold w-100"
                    onClick={this.handleSubmit}
                  >
                    Sign In
                  </button>
                </div>
                <div class="form-group col-lg-12 mx-auto d-flex align-items-center my-4">
                  <div class="border-bottom w-100 ml-5"></div>
                  <span class="px-2 small text-muted font-weight-bold text-muted">
                    OR
                  </span>
                  <div class="border-bottom w-100 mr-5"></div>
                </div>
                <div className="d-flex">
                  <MicrosoftLoginButton
                    setError={this.setErrorMessage.bind(this)}
                  />
                </div>
                <div className="d-flex justify-content-end my-4">
                  <a
                    href="javascript:;"
                    className="text-dark-50 text-hover-primary my-3 mr-2"
                    id="kt_login_forgot"
                  >
                    Forgot Password ?
                  </a>
                </div>
              </form>
            </div>
            {/* <Signup/> */}
            <Forgetpass props={this.state} />
          </div>

          <div className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
            <div className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2">
              © 2020 Powerweave
            </div>
            {/* <div className="d-flex order-1 order-sm-2 my-2">
                        <a href="#" className="text-dark-75 text-hover-primary">Privacy</a>
                        <a href="#" className="text-dark-75 text-hover-primary ml-4">Legal</a>
                        <a href="#" className="text-dark-75 text-hover-primary ml-4">Contact</a>
                    </div> */}
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(Login);
